
import { WorldCountry } from './types';

export const israelData: WorldCountry = {
  code: 'IL',
  name: 'Israel',
  slug: 'israel',
  population: 9364000,
  topCities: [
    { name: 'Jerusalem', slug: 'jerusalem', population: 936425 },
    { name: 'Tel Aviv', slug: 'tel-aviv', population: 460613 },
    { name: 'Haifa', slug: 'haifa', population: 285316 },
    { name: 'Rishon LeZion', slug: 'rishon-lezion', population: 254384 },
    { name: 'Petah Tikva', slug: 'petah-tikva', population: 247956 },
    { name: 'Ashdod', slug: 'ashdod', population: 225975 },
    { name: 'Netanya', slug: 'netanya', population: 221353 },
    { name: 'Beer Sheva', slug: 'beer-sheva', population: 209687 },
    { name: 'Holon', slug: 'holon', population: 196282 },
    { name: 'Bnei Brak', slug: 'bnei-brak', population: 193774 }
  ]
};
